import { isNumber } from '../isNumber/isNumber';
const PLURAL_NUMBER_SUFFIX_MAP = new Map([
    ['one', 'st'],
    ['two', 'nd'],
    ['few', 'rd'],
    ['other', 'th'],
]);
/**
 * Make number value to be represented as number with plural suffix.
 *
 * @param {string | number} value Number.
 * @returns {string}
 *
 * @example
 * pluralizeNumber(0); // '0th'
 * pluralizeNumber(1); // '1st'
 * pluralizeNumber(2); // '2nd'
 * pluralizeNumber(3); // '3rd'
 * pluralizeNumber(4); // '4th'
 * pluralizeNumber(11); // '11th'
 * pluralizeNumber(21); // '21st'
 * pluralizeNumber(42); // '42nd'
 * pluralizeNumber(103); // '103rd'
 */
export function pluralizeNumber(value) {
    // Implementation was taken from here:
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/PluralRules#formatting_text_using_the_returned_tag
    try {
        const numericValue = Number(value);
        if (!numericValue || !isNumber(numericValue)) {
            return value;
        }
        const rule = new Intl.PluralRules('en-US', { type: 'ordinal' }).select(Number(value));
        const suffix = PLURAL_NUMBER_SUFFIX_MAP.get(rule);
        return `${value}${suffix}`;
    }
    catch (e) {
        return value;
    }
}
